export enum BraintreeFieldType {
  INPUT = 'Input',
  SELECT = 'Select',
}
